import { StyleSheet } from "react-native";
import type { UiTheme } from "@jackedlogs/ui";

// Layout-only styles for TimersScreen.tsx — card shells come from the shared
// makeSettingsCardStyles instead (see TimersScreen.tsx). Split out to keep
// the screen under the 350-line soft-warning threshold, mirroring
// apps/mobile/src/screens/restDefaultsStyles.ts's own split.
export function makeTimersScreenStyles(theme: UiTheme) {
  const { palette: p, spacing: s, radius: r, typography: t } = theme;
  return StyleSheet.create({
    flex: { flex: 1, backgroundColor: p.bg },
    body: { paddingHorizontal: s.s5, paddingVertical: s.s4, gap: s.s4 },
    center: { flex: 1, alignItems: "center", justifyContent: "center", backgroundColor: p.bg },
    error: { color: p.danger, fontSize: t.sizes.base },
    row: { flexDirection: "row", alignItems: "center", gap: s.s3, minHeight: 44 },
    rowText: { flex: 1, gap: 2 },
    rowTitle: { color: p.ink, fontSize: t.sizes.base, fontWeight: "600" },
    rowSub: { color: p.ink3, fontSize: t.sizes.sm, fontVariant: ["tabular-nums"] },
    // Visible error line paired with the field's `invalid` state (never colour-only).
    rowError: { color: p.danger, fontSize: t.sizes.xs },
    // Layout only — box internals live in the <TextField> primitive.
    input: {
      width: 72,
    },
    unit: { width: 16, color: p.ink3, fontSize: t.sizes.sm },
    saveBtn: {
      minHeight: 40,
      paddingHorizontal: s.s4,
      borderRadius: r.r3,
      backgroundColor: p.brand500,
      alignItems: "center",
      justifyContent: "center",
    },
    saveBtnDisabled: { opacity: 0.4 },
    saveBtnPressed: { opacity: 0.8 },
    saveBtnText: { color: p.inkOnBrand, fontSize: t.sizes.base, fontWeight: "600" },
    customHeader: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    // react-native-web's Pressable doesn't implement hitSlop (DS-48) — the
    // 44pt floor here is a real minHeight, not padding out from a smaller box.
    addBtn: {
      minHeight: 44,
      paddingHorizontal: s.s3,
      justifyContent: "center",
    },
    addBtnPressed: { opacity: 0.6 },
    addBtnText: { color: p.brand500, fontSize: t.sizes.base, fontWeight: "600" },
    emptyText: { color: p.ink3, fontSize: t.sizes.sm },
    customRow: {
      flexDirection: "row",
      alignItems: "center",
      gap: s.s2,
      minHeight: 44,
      borderTopWidth: 1,
      borderTopColor: p.border,
      paddingTop: s.s3,
      marginTop: s.s3,
    },
    customRowPressed: { opacity: 0.6 },
    customRowName: { flex: 1, color: p.ink, fontSize: t.sizes.base, fontWeight: "500" },
    overrideChip: { flexDirection: "row", alignItems: "center", gap: 2 },
    overrideChipText: { color: p.ink2, fontSize: t.sizes.xs, fontVariant: ["tabular-nums"] },
  });
}
